import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  answerType: PropTypes.string.isRequired,
  answerContent: PropTypes.string.isRequired,
  userAnswers: PropTypes.array.isRequired,
  userAnswersCorrect: PropTypes.array.isRequired,
  onAnswerSelected: PropTypes.func.isRequired,
};

function AnswerOption(props) {
  const isSelectedClass = ( props.answerType === props.userAnswers[props.subQuestionNumber] ? '-selected' : '');
  const isDisabledClass = ( props.disableAnswerButtons ? ' -disabled' : '');

  let isCorrectClass = '';
  if( props.userAnswersCorrect[props.subQuestionNumber] === true && props.answerType === props.userAnswers[props.subQuestionNumber] ){
    isCorrectClass = ' -correct';
  } else if ( props.userAnswersCorrect[props.subQuestionNumber] === false && props.answerType === props.userAnswers[props.subQuestionNumber] ) {
    isCorrectClass = ' -incorrect';
  }

  return (
    <li className={"answerOption " + isSelectedClass + isCorrectClass + isDisabledClass}>
      <input
        type="radio"
        className="radioCustomButton"
        name="radioGroup"
        checked={props.answerType === props.answer}
        id={props.subQuestionNumber + props.answerType}
        value={props.answerType}
        disabled={props.disableAnswerButtons}
        onChange={props.onAnswerSelected.bind(this, props.subQuestionNumber)}
      />
      <label className="radioCustomLabel" htmlFor={props.subQuestionNumber + props.answerType}>
        {props.answerContent}
      </label>
    </li>
  );
}

AnswerOption.propTypes = propTypes;

export default AnswerOption;


/** WEBPACK FOOTER **
 ** ./src/components/AnswerOption.js
 **/